import React, { useState, useRef } from 'react';
import bem from 'utils/bem';
import CommonDateTimeInput from './CommonDateTimeInput';
import PopoverDateTimeField from './PopoverDateTimeField';

import './index.sass';

const { cnBlock } = bem('datetime-field');

export default ({ className, Input = CommonDateTimeInput, Popup = PopoverDateTimeField, value, placeholder, error, ...rest }) => {
    const [ open, setOpen ] = useState(false);
    const inputRef = useRef(null);

    const onClick = () => {
        setOpen(_open => !_open);
    };

    const onClose = () => {
        setOpen(false);
    }

    return <div className={ cnBlock(className) }>
        <span ref={inputRef}>
            <Input onClick={ onClick } value={ value } placeholder={placeholder} error={error}/>
        </span>
        <Popup
            {...rest}
            anchorEl={ inputRef?.current }
            open={ open }
            onClose={ onClose }
            value={ value }
        />
    </div>;
}
